import { BookHeart, Calendar, TrendingUp, Utensils } from "lucide-react";

export default function PhoneMockup() {
  return (
    <div
      data-testid="phone-mockup"
      className="relative animate-float-slow"
      style={{ width: 300, maxWidth: "100%" }}
    >
      {/* Phone body */}
      <div
        className="fp-phone-shadow relative rounded-[44px] p-3"
        style={{
          background: "var(--fp-espresso)",
          border: "2px solid rgba(0,0,0,0.15)",
          transform: "rotate(-3deg)",
        }}
      >
        {/* Notch */}
        <div
          className="absolute top-4 left-1/2 -translate-x-1/2 rounded-full z-10"
          style={{
            width: 90,
            height: 22,
            background: "#1a0f09",
          }}
        />

        {/* Screen */}
        <div
          className="rounded-[34px] overflow-hidden"
          style={{ background: "var(--fp-cream)", aspectRatio: "9/19.5" }}
        >
          {/* Status bar */}
          <div
            className="flex items-center justify-between px-6 pt-3 text-[10px] font-semibold"
            style={{ color: "var(--fp-espresso)" }}
          >
            <span>9:41</span>
            <div className="flex items-center gap-1">
              <div
                className="w-3.5 h-2 rounded-sm"
                style={{ background: "var(--fp-espresso)" }}
              />
            </div>
          </div>

          {/* App header */}
          <div className="px-5 pt-8">
            <p
              className="text-[10px] uppercase tracking-widest"
              style={{ color: "var(--fp-ink-muted)" }}
            >
              Mardi 14 mai
            </p>
            <h3
              className="font-display text-xl font-semibold mt-1"
              style={{ color: "var(--fp-espresso)" }}
            >
              Salut Camille 👋
            </h3>
            <p
              className="text-[11px] mt-0.5"
              style={{ color: "var(--fp-ink-muted)" }}
            >
              Comment va ton ventre aujourd'hui ?
            </p>
          </div>

          {/* Quick log card */}
          <div className="px-5 mt-5">
            <div
              className="rounded-2xl p-4"
              style={{
                background: "var(--fp-powder)",
                color: "var(--fp-espresso)",
              }}
            >
              <div className="flex items-center gap-2 mb-2">
                <BookHeart size={14} strokeWidth={2.2} />
                <span className="text-[11px] font-semibold uppercase tracking-wider">
                  Entrée rapide
                </span>
              </div>
              <div className="grid grid-cols-7 gap-1.5">
                {[1, 2, 3, 4, 5, 6, 7].map((n) => (
                  <div
                    key={n}
                    className="aspect-square rounded-lg flex items-center justify-center text-[11px] font-bold"
                    style={{
                      background:
                        n === 4
                          ? "var(--fp-terracotta)"
                          : "rgba(255, 240, 238, 0.55)",
                      color:
                        n === 4 ? "var(--fp-cream)" : "var(--fp-espresso)",
                    }}
                  >
                    {n}
                  </div>
                ))}
              </div>
              <p className="text-[10px] mt-2 opacity-80">
                Échelle de Bristol
              </p>
            </div>
          </div>

          {/* Trend mini chart */}
          <div className="px-5 mt-4">
            <div
              className="rounded-2xl p-4"
              style={{
                background: "#ffffff",
                border: "1px solid var(--fp-border)",
              }}
            >
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-1.5">
                  <TrendingUp
                    size={13}
                    strokeWidth={2.4}
                    style={{ color: "var(--fp-terracotta)" }}
                  />
                  <span
                    className="text-[11px] font-semibold"
                    style={{ color: "var(--fp-espresso)" }}
                  >
                    Cette semaine
                  </span>
                </div>
                <span
                  className="text-[10px] font-medium"
                  style={{ color: "var(--fp-ink-muted)" }}
                >
                  7j
                </span>
              </div>
              <div className="flex items-end justify-between gap-1 h-16">
                {[40, 60, 35, 75, 55, 80, 65].map((h, i) => (
                  <div
                    key={i}
                    className="flex-1 rounded-t-md"
                    style={{
                      height: `${h}%`,
                      background:
                        i === 5
                          ? "var(--fp-terracotta)"
                          : "var(--fp-rose-gold)",
                      opacity: i === 5 ? 1 : 0.55,
                    }}
                  />
                ))}
              </div>
              <div
                className="flex justify-between mt-1.5 text-[9px]"
                style={{ color: "var(--fp-ink-muted)" }}
              >
                <span>L</span>
                <span>M</span>
                <span>M</span>
                <span>J</span>
                <span>V</span>
                <span>S</span>
                <span>D</span>
              </div>
            </div>
          </div>

          {/* Bottom tab bar */}
          <div
            className="absolute bottom-0 left-0 right-0 mx-3 mb-3 rounded-2xl px-4 py-3 flex items-center justify-around"
            style={{
              background: "#ffffff",
              border: "1px solid var(--fp-border)",
            }}
          >
            {[
              { Icon: BookHeart, active: true },
              { Icon: TrendingUp, active: false },
              { Icon: Utensils, active: false },
              { Icon: Calendar, active: false },
            ].map(({ Icon, active }, i) => (
              <div
                key={i}
                className="flex flex-col items-center gap-0.5"
                style={{
                  color: active
                    ? "var(--fp-terracotta)"
                    : "var(--fp-ink-muted)",
                }}
              >
                <Icon size={16} strokeWidth={active ? 2.5 : 2} />
                {active && (
                  <div
                    className="w-1 h-1 rounded-full"
                    style={{ background: "var(--fp-terracotta)" }}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Floating label */}
      <div
        className="absolute -right-4 top-8 px-3 py-2 rounded-xl text-xs font-semibold animate-float"
        style={{
          background: "#ffffff",
          color: "var(--fp-espresso)",
          border: "1px solid var(--fp-border)",
          boxShadow: "0 8px 24px -10px rgba(147, 93, 61, 0.3)",
        }}
      >
        <div className="flex items-center gap-1.5">
          <div
            className="w-2 h-2 rounded-full"
            style={{ background: "#6ab07a" }}
          />
          Journée stable
        </div>
      </div>
    </div>
  );
}
